import React, { useState, useEffect, FC } from 'react'
import { Table, Button, Input } from 'antd'
import { YHModal } from '@/components/YHModal'
import { useAssetsAbandonDetailsModel } from './assetsAbandonDetailsModel'
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table'
import { YhBox } from '@/components/YhBox'
import { ISearchPage } from '@/types/AppTypes'
import useGlobalModel from '@/model/globalModel'
import { YhBut } from '@/components/YhButton'
import { formatNum, formatInt, transPgToPagination } from '@/utils/utils'
import { RouterParamType } from '@/model/navModel'
import { EditableRow, EditableCell } from '@/components/YHEditTable/editTable'
import { ISCMORVRMTransferSearchFields, ISCMORVRMTransferDetails } from '../../assetsAbandonTypes'
import { assetsAbandonService } from '../../assetsAbandonService'
import { debounce } from 'lodash'
import { useDictModel } from '@/views/base/dict/dictModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import YhTootip from '@/components/YhTootip'
import { DEFAULT_PAGE_SIZE } from '@/utils/constants'

enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2,
}

//为已添加的商品增加 数量字段
export interface ISCMSDcSelectGoods extends ISCMORVRMTransferDetails {
    price: number
    brandCode: string
    brandName: string
}

export const AddGoodsModal: FC<RouterParamType> = ({ id, mode }) => {
    const {
        addGoodsModal: visible,
        setAddGoodsModal,
        add,
        remove,
        addSelectGoods,
        setAddSelectGoods,
        addGoodsList,
        editGoodsList,
        editSelectGoods,
        setEditSelectGoods,
        transformsToSDcGoods,
        editFormVal,addFormVal
    } = useAssetsAbandonDetailsModel()
    const { getSelectedDictOne,getTreeNodeName } = useDictModel()
    //查询条件
    const [searchParam, setSearchParam] = useState<ISCMORVRMTransferSearchFields>({})
    //列表数据源
    const [dataSource, setDataSource] = useState<ISCMORVRMTransferDetails[]>([])
    //列表数据源分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: 10, current: 1 }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    const [bool, setBool] = useState<boolean>(false) //用变量来触发全局事件 ， 否咋拿不到全局状态里面的缓存数据
    const formData= mode === "edit" ?editFormVal:addFormVal;

    const loadData = async (page?: ISearchPage) => {
        let searchParams:any = {
            ...searchParam,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: page?.pageNum ?? pgCfg.current,
            inventoryNum:0,
            department:mode === 'add' ?addFormVal.department: editFormVal.department
        }
        if(formData.typeCode=='assets-discard.preturn'){
            searchParams.type='assets.storage'
        }else{
            searchParams.typeList=['assets.receive','assets.transfer']
        }
        let { retData } = await assetsAbandonService.assetsListDetails(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(records)
    }

    const onGlobalKeyUp = (e: KeyboardEvent) => {
        if (e.ctrlKey && e.keyCode === 13) {
            setBool((origin) => !origin)
        }
    }

    //注册window的crtl+回车事件来触发当前 弹框确认事件
    useEffect(() => {
        if (visible) {
            document.onkeyup = onGlobalKeyUp
            loadData()
        } else {
            document.onkeyup = null
            setBool(false)
        }
    }, [visible])

    useEffect(() => {
        return () => {
            document.onkeyup = null
            setBool(false)
        }
    }, [])

    const onCancel = () => {
        setAddGoodsModal(false)
    }

    const column = (optype: number) =>
        [
            {
                title: '序号',
                width: 50,
                fixed: 'left',
                align: 'center',
                render: (t: any, r: any, i: number) => <>{i + 1}</>,
            },
            {
                title: '物资编码',
                width: 160,
                dataIndex: 'materialCode',
                fixed: 'left',
            },
            {
                title: '条形码',
                width: 160,
                dataIndex: 'barCode',
            },
            {
                title: '物资名称',
                width: 180,
                dataIndex: 'materialName',
            },
            {
                title: '规格型号',
                width: 130,
                dataIndex: 'model',
                render: (text: string) =><YhTootip text={text} />,
            },
            {
                title: '物资类型',
                width: 120,
                dataIndex: 'typeCode',
                render: (text: string) => getTreeNodeName(text) ?? ''            },
            {
                title: '采购单号',
                width: 140,
                dataIndex: 'code', //这里取采购数量的值判断
            },
            {
                title: '当前使用人',
                width: 130,
                dataIndex: 'user',
                // editable: true,
            },
            {
                title: '单价',
                width: 100,
                dataIndex: 'price',
                // editable: true,
            },
            {
                title: '单位',
                width: 60,
                dataIndex: 'unitCode',
                render: (text: string) => getSelectedDictOne(DictCodeEnmu.ASSETS_UNIT).find((item) => item.value === text)?.label ?? '',                
            },
            {
                title: '操作',
                width: 80,
                fixed: 'right',
                align: 'center',
                className: 'td-wrap',
                render: (text: any, record: ISCMSDcSelectGoods) =>
                    optype === OPT_TYPE.ADD ? (
                        <YhBut
                            type="add"
                            txt="添加"
                            click={() => add(record, mode)}
                            disabled={
                                !!(mode === 'edit' ? editSelectGoods : addSelectGoods).find((item) => item.id === record.id) ||
                                !!(mode === 'edit' ? editGoodsList : addGoodsList).find((item) => item.materialCode === record.materialCode) ||
                                +record.inventoryQuantity <= 0
                            }
                        />
                    ) : (
                        <YhBut type="delete" txt="删除" click={() => remove(record, mode)} />
                    ),
            },
        ].filter((i) => i)

    const newSelectColumns = column(OPT_TYPE.REMOVE).map((col: any, index) => {
        return {
            ...col,
            onCell: (record: ISCMSDcSelectGoods, rowIndex: number) => ({
                colIndex: index,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                editable: col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: any) => {
        row.sDcNum = +formatNum(row.sDcNum)
        let dataSource = mode === 'edit' ? editSelectGoods : addSelectGoods
        const index = dataSource.findIndex((item) => row.id === item.id)
        const item = dataSource[index]
        dataSource.splice(index, 1, { ...item, ...row })
        mode === 'edit' ? setEditSelectGoods([...dataSource]) : setAddSelectGoods([...dataSource])
    }

    const rightChildren = (
        <div className="flex">
            <Input
                size="small"
                allowClear
                datatype="round"
                className="border-r-8 ml-10"
                placeholder="请输入条形码"
                value={searchParam?.barCode}
                onChange={(e) => setSearchParam({ ...searchParam, barCode: e.target.value })}
                onBlur={(e) => {
                    setSearchParam({ ...searchParam, barCode: e.target.value?.trim() })
                }}
                onPressEnter={() => loadData(initPgCfg)}
            />
            <Input
                size="small"
                allowClear
                datatype="materialCode"
                className="border-r-8 ml-10"
                placeholder="请输入物资编码"
                value={searchParam?.materialCode}
                onChange={(e) => setSearchParam({ ...searchParam, materialCode: e.target.value })}
                onBlur={(e) => {
                    setSearchParam({ ...searchParam, materialCode: e.target.value?.trim() })
                }}
                onPressEnter={() => loadData(initPgCfg)}
            />
            <Input
                size="small"
                allowClear
                datatype="round"
                className="border-r-8 ml-10"
                placeholder="请输入物资名称"
                value={searchParam?.materialName}
                onChange={(e) => setSearchParam({ ...searchParam, materialName: e.target.value?.trim() })}
                onPressEnter={() => loadData(initPgCfg)}
            />
            <Button style={{ margin: '2px 0 0px 15px' }} type="primary" size={'large'} onClick={() => loadData(initPgCfg)}>
                检索
            </Button>
        </div>
    )

    return (
        <YHModal
            visible={visible}
            onOk={debounce(() => transformsToSDcGoods(mode === 'edit' ? editSelectGoods : addSelectGoods, mode), 500)}
            onCancel={onCancel}
            title="物资明细"
            width={1200}
            bodyHeight={730}
            showFooter={true}
        >
            <YhBox title="待添加物资列表" rightChildren={rightChildren} style={{ marginBottom: '5px', paddingBottom: 0, padding: 0 }}>
                <Table
                    bordered
                    rowKey={(record) => record.id}
                    columns={column(OPT_TYPE.ADD) as ColumnsType<ISCMORVRMTransferDetails>}
                    dataSource={dataSource}
                    pagination={{
                        ...pgCfg,
                        position: ['bottomCenter'],
                        onChange: (pageNum, pageSize) => {
                            loadData({ pageNum, pageSize })
                        },
                    }}
                    scroll={{ x: 'max-content', y: 200 }}
                />
            </YhBox>
            <YhBox title="已选物资列表" style={{ padding: 0 }}>
                <Table
                    bordered
                    rowKey={(record) => record.id}
                    rowClassName="editable-row yh-edit-table-tr"
                    components={{
                        body: {
                            row: EditableRow,
                            cell: EditableCell,
                        },
                    }}
                    columns={newSelectColumns}
                    dataSource={mode === 'edit' ? editSelectGoods : addSelectGoods}
                    pagination={false}
                    scroll={{ x: 'max-content', y: 200 }}
                />
            </YhBox>
        </YHModal>
    )
}
